export const EVENT_NAMES = {
  FOLLOW: 'Follow',
  FILTER_AUDIENCE: 'ALL_Filter Audience',
  FILTER: 'ALL_Filter',
  SEARCH: 'Search',
  EXPORT: 'Export',
  SORT: 'ALL_Sort',
  PAGE_VIEW: 'ALL_Page View',
  VIDEO_VIEW: 'Video View',
  COMPARE: 'ALL_Compare',
  LOGIN: 'Login',
  CLICK_TOPIC: 'Topic Select',
  SELECT_CATEGORY: 'Category Select',
  REPORT_ISSUE: 'Report Issue',
  CLOSE_MODAL: 'Close Modal',
  DELETE_JOB: 'Delete Job',
  CREATE_JOB: 'Create Job',
  EDIT_JOB: 'Edit Job',
  NEW_JOB: 'New Job',
  START_NEW_JOB: 'Start New Job',
  ONBOARDING_START: 'Onboarding Start',
  ONB: {
    START: 'ONB_Start Onboarding',
    SELECT_AREA: 'ONB_Select Area',
    SELECT_OTHER_AREA: 'ONB_Select Other Area',
    SELECT_SENIORITY: 'ONB_Select Seniority level',
    SELECT_OTHER_SENIORITY: 'ONB_Select Other seniority level',
    SELECT_USE_CASE: 'ONB_Select Use case',
    FINISH: 'ONB_Finish Onboarding',
  },
  CREATE_NEW_REPORT: 'Create New Report',
  START_NEW_REPORT: 'Start New Report',
  CREATE_REPORT: 'Create Report',
  EDIT_REPORT: 'Edit Report',
  DELETE_REPORT: 'Delete Report',
  NEW_REPORT: 'New Report',
  PASSWORD_CHANGE: 'Password change',
  CREATE_REPORT_TEMPLATE: 'Create report on add template on topic/creator page',
  CREATE_TEMPLATE: 'Create template slide to report builder',
  MEMBERS_MANAGEMENT_INVITE: 'Members management invite',
  MEMBERS_MANAGEMENT_EDIT: 'Members management edit',
  MEMBERS_MANAGEMENT_REMOVE: 'Members management remove',
  COPY_LINK: 'Copy link',
  OPEN_LINK: 'Open link',
  ADD_TO: 'ALL_Add To',
  ADDED_TO_JOB: 'Added To Job',
  ADDED_TO_REPORT: 'Added To Report',
  VIDEO_ANALYTICS: 'Video Analytics',
  HELP_VIDEO: 'Search Help Video',
  HELP_CENTER: 'Help center',
  DUPLICATE_JOB: 'Duplicate Job',
  DUPLICATE_REPORT: 'Duplicate Report',
  CREATOR_SUGGESTION: 'Creator Suggestion',
  TARGET_AUDIENCE_SAVE: 'Save Target Audience',
  CREATE_WINNIN_REPORT: 'Create Winnin Report',
  EDIT_WINNIN_REPORT: 'Edit Winnin Report',
  DELETE_WINNIN_REPORT: 'Delete Winnin Report',
  OPEN_WINNIN_REPORT: 'Open Winnin Report',
  CLICK_TRENDING_TAG: 'Click Trending Tag',
  CLICK_TOPIC_TRENDING_TAG: 'Click Topic Trending Tag',
  WORKSPACE_COPY_LINK: 'Workspace Copy Link',
  NICHE: 'Niche',
  SEE_MORE_ABOUT: 'See More About',
  NEW_HOME: 'New Home',
  INTEREST_UNFOLLOW: 'Interest Unfollow',
  CLICK_WEEKLY_HIGHLIGHTS: 'Click Weekly Highlights',
  GLOBAL_HIGHLIGHTS_LANGUAGE: 'Global Highlights Language',
  CLICK_TRENDING_SUBTOPICS: 'Click Trending Subtopics',
  CLICK_TALK_TO_US: 'Click Talk to Us',
  CLICK_TOPIC_OVERVIEW: 'Click topic overview',
  COMPETITOR_ADD: 'Added a competitor',
  METRICS_FILTER: 'Metrics filter',
  METRICS_TOGGLE: 'Metrics toggle',
  ADD_COMPETITOR: 'Add competitor',
  REMOVE_COMPETITOR: 'Removed a competitor',
  SEARCH_COMPETITOR: 'Search competitor',
  ADD_INTEREST: 'Add Interest',
  SORT_REPORTS: 'Sort reports',
  CLICK_JOB: 'Click job',
  CLICK_SAVED_SEARCH: 'Click saved search',
  SAVED_SEARCH_VISIT: 'Saved search visit',
  SAVED_SEARCH: 'Saved search',
  START_SAVING_SEARCH: 'Start saving search',
  DELETE_SEARCH: 'Delete search',
  RENAME_SEARCH: 'Rename search',
  HIGHLIGHTS_TAG: 'Highlights tag',
  GET_ALERT: 'Get alert',
  CREATE_ALERT: 'Create alert',
  UPDATE_ALERT: 'Update alert',
  DISABLE_ALERT: 'Disable alert',
  INSERT_CREATOR: {
    CLICK: 'Insert Creator',
    INVALID_URL: 'Invalid URL',
    REQUEST_CREATOR: 'Request creator',
    EXISTING_CREATOR: 'Existing Creator',
  },
  INSERT_CONTENT: {
    CLICK: 'Insert Content',
    INVALID_URL: 'Invalid URL',
    REQUEST_CONTENT: 'Request Content',
    EXISTING_CONTENT: 'Existing Content',
  },
  INSERT_POST: {
    REQUEST_POST: 'Request Post',
    EXISTING_POST: 'Existing Post',
  },
  CREATOR_CLICK: 'Creator click',
  CREATOR_TALKING_ABOUT: 'Creator Talking About',
  CREATOR_HEADER: {
    CONTACT_LINK_CLICK: 'Click link',
    MOST_USED_TAGS_TAB_CLICK: 'Most used tags',
    ABOUT: 'About',
    TAG_CLICK: 'Tags',
  },
  TAG_PAGE: 'Tag page',
  CREATOR_CUSTOMIZE: {
    EDIT_COLOR: 'Edit creator color',
    HIDE_CREATOR: 'Hide creator',
    SHOW_CREATOR: 'Show creator',
  },
  ITEM_SELECTED: 'ALL_Select Item',
  ITEM_REMOVED: 'ALL_Remove Item',
  REMOVE_FROM_JOB: 'Remove from job',
  CHANGE_DASHBOARD_COMPONENT_METRIC: 'Change Dashboard Component Metric',
  CLICK_TOPIC_SUGGESTION: 'CRE_Click Topic Suggestion',
  NPS: 'NPS',
  OPEN_DASHBOARD: 'Open dashboard',
  CLICK_DASHBOARDS: 'Click Dashboards',
  ADDED_TO_DASHBOARD: 'Added to dashboard',
  PUBLIC_DASHBOARD: 'Public dashboard',
  SHARE_DASHBOARD: 'Share dashboard',
  DASHBOARD_ACCESS: 'Dashboard access',
  DASHBOARD_NEW_PASSWORD: 'Dashboard new password',
  DASHBOARD_PASSWORD_CHANGE: 'Dashboard password change',
  FULL_SCREEN_MODE: 'Full screen mode',
  PROVIDER_REQUEST: {
    OPEN: 'Provider request open',
    MADE: 'Provider request made',
  },
  GRAPH_VIEW: 'Graph view',
  DASHBOARD_COMPONENT: {
    DELETED: 'Deleted Dashboard Component',
    EDITED: 'Edited Dashboard Component',
    DUPLICATED: 'Duplicated Dashboard Component',
  },
  SIGNUP_PAGE: {
    SIGN_UP_INVITE: 'Sign up invite',
    SEND_REGISTRATION: 'Send registration',
  },
  DATE_CHART_CLICK: 'Date chart click',
  CLUSTER: {
    CLUSTER_CLICK: 'TOP_Click Cluster',
    CLUSTER_SEE_MORE: 'Cluster see more',
    CLICK_CREATOR: 'Click creator',
    PROVIDER_SEE_MORE: 'Provider see more',
    SEE_VIDEOS: 'See videos',
    SEE_ALL: 'See all',
  },
  SHARE_BUTTON: {
    CLICK: 'ALL_Start Share',
    PLATFORMS: 'ALL_Select Share Platform',
    COMPLETED: 'ALL_Finish Share',
  },
  PUBLIC_CREATOR: {
    TALK_TO_US: 'Talk to us CTA',
    LOGIN: 'Click here to login CTA',
  },
  TOPIC_SUGGEST: 'Topic suggest',
  SUBTOPIC_SUGGEST: 'Subtopic suggest',
  REQUEST_ACCESS: 'Request access',
  ACCEPT_REQUEST: 'Accept access',
  DECLINE_ACCESS: 'Decline access',
  SAVE_TEMPLATE: 'Save template',
  START_WITH_TEMPLATE: 'Start with template',
  COMPARE_FILTER_CHANGE: 'COM_Filter Range',
  COMPARE_CHART_CLICK: 'COM_Click Chart',
  EDIT_SAVED_SEARCH: {
    EDIT_SEARCH: 'Edit saved search',
    SEARCH_TERM: 'Searched new term',
  },
  SEE_MORE: 'See more',
  TOPIC_ALSO_WATCH: 'TOP_Click Also Watch Topic',
  DASHBOARD_THEME: {
    OPEN: 'Open customization',
    APPLY: 'Apply customization',
    CANCEL: 'Cancel customization',
    CUSTOMIZE_DASHBOARD: 'Customize dashboard',
    CHANGE_COLOR: 'Change color',
  },
  SEE_ALL_REPORTS: 'See all reports',
  REPORTS_FILTER: 'Reports filter',
  SEARCH_REPORT: 'Search Winnin Reports',
  REASON_TO_REGENERATE: 'Reason to regenerate',
  DEACTIVATE_ALERT: 'Deactivate alert',
  REASON_TO_UNSUBSCRIBE: 'Reason to unsubscribe',
  HOME_ALERT: {
    CLICK: 'Click alert',
    APPLY: 'Apply alert',
  },
  OPEN_DASHBOARD_DOCUMENT: 'Open embeded document',
  PUBLISH_NEW_REPORT: 'Publish new report',
  AI_REPORT_CLICK: 'AI Report Click',
  CLICK_DASHBOARD_FILTER: 'Click dashboard filter',
  CHANGE_DASHBOARD_FILTER: 'Change dashboard filter',
  CLICK_HISTORY: 'Click history',
  CLICK_VERSION: 'Click version',
  RESTORE_VERSION: 'Restore version',
  CANCEL_HISTORY: 'Cancel history',
  CREATE_JOB_FOLDER: 'Create job folder',
  EDIT_JOB_FOLDER: 'Edit job folder',
  DELETE_JOB_FOLDER: 'Delete job folder',
  OPEN_JOB_FOLDER: 'Open job folder',
  JOB_TAB_CHANGE: 'Change job tab',
  FOLDER_TAB_CHANGE: 'Folder job tab',
  TRENDING_TAGS_PLATFORM_CHANGE: 'Trending tags platform',
  TRENDING_TAGS_LANGUAGE_CHANGE: 'Trending tags language',
  HOT: {
    TRENDING_TAGS_TYPE_CHANGE: 'Trending tags type select',
    TRENDING_TAGS_DATE_CHANGE: 'Trending tags date select',
  },
  CLICK_TRENDING_TAG_ITEM: 'Trending tags click',
  CLICK_TRENDING_TAG_VIDEO: 'Trending tags click video',
  SEE_ALL_TOPICS: 'TOP_View All Topics',
  SEE_ALL_VIDEOS: 'See all videos',
  CLICK_FORMAT: 'TOP_Click Format',
  CLICK_TERRITORY: 'Click territory',
  CLICK_HASHTAG: 'Click hashtag',
  TERRITORY_LANGUAGE_BLOCK: 'Territory language block',
  CHANGE_AVERAGE_FILTER: 'COM_Change Average Filter',
  SHORTCUT_CLICK: 'Shortcut click',
  TRENDING_CLICK: 'Trending click',
  UNDO: 'Dashboard undo',
  REDO: 'Dashboard redo',
  CLICK_VIDEO: 'Click video',
  SETUP_INCLUDE_BRAND_CHANNELS: 'Include Brand Channels',
  SETUP_CREATE_COMPETITOR: 'Create competitor',
  SETUP_INCLUDE_COMPETITOR_CHANNELS: 'Include competitor Channels',
  SETUP: {
    SELECT_BRAND_NAME: 'Select brand name',
    SELECT_ANOTHER_BRAND_NAME: 'Select another brand name',
    CLICK_CONTINUE_TO_BRAND_CHANNELS: 'Click continue to brand channels',
    CLICK_ADVANCED_MODE: 'Click advanced mode',
    FILTER_ADVANCED_MODE: 'Filter advanced mode',
    EXIT_ADVANCED_MODE: 'Exit advanced mode',
    CLICK_BACK_TO_BRAND_NAME: 'Click back to brand name',
    INCLUDE_BRAND_CHANNELS: 'Include brand channels',
    SELECT_COMPETITOR_NAME: 'Select competitor name',
    SELECT_ANOTHER_COMPETITOR_NAME: 'Select another competitor name',
    CLICK_CONTINUE_TO_COMPETITOR_CHANNELS: 'Click continue to competitor channels',
    CLICK_BACK_TO_COMPETITOR_NAME: 'Click back to competitor name',
    INCLUDE_COMPETITOR_CHANNELS: 'Include competitor channels',
    SEE_ANALYSIS: 'See analysis',
    SETUP_UGC_START: 'Setup UGC start',
    ADD_NEW_TERM: 'Add new term',
    DELETE_TERM: 'Delete term',
    SELECT_TERM: 'Select term',
    CLICK_ADVANCED_MODE_UGC: 'Click advanced mode UGC',
    EXIT_ADVANCED_MODE_UGC: 'Exit advanced mode UGC',
    INCLUDE_BRAND_UGC: 'Include brand UGC',
    CONFIGURE_COMPETITOR_UGC: 'Configure competitor UGC',
    ADD_NEW_TERM_UGC_COMPETITOR: 'Add new term UGC competitor',
    DELETE_TERM_UGC_COMPETITOR: 'Delete term UGC competitor',
    SELECT_TERM_UGC_COMPETITOR: 'Select term UGC competitor',
    INCLUDE_COMPETITOR_UGC: 'Include competitor UGC',
    SEE_ANALYSIS_UGC: 'See analysis UGC',
    EDIT_BRAND_NAME: 'Edit brand name',
    EDIT_COMPETITOR_NAME: 'Edit competitor name',
    ACTIVATE_COMPETITOR: 'Activate competitor',
    CONTINUE_UGC_COMPETITOR: 'BRA_Continue UGC competitor',
  },
  BRAND: {
    CHANGE_COLOR: 'Change color',
    CLICK_QUESTION: 'Click question',
    ZAI_ERROR: 'Zai error',
    ZAI_ANSWER: 'Zai answer',
    ZAI_KEY_FINDING: {
      MODAL_REACTION: 'Zai key finding modal reaction',
      CLICK_KEY_FINDING: 'BRA_Select KeyFinding',
      CLICK_CATEGORY: 'BRA_Switch KeyFinding',
    },
    ZAI_GRAPHIC_QUESTION: {
      MODAL_REACTION: 'Zai graphic question modal reaction',
    },
    HERO_TITLE_CLICK_BRAND: 'BRA_Click Hero Title Brand',
    SENTIMENT: {
      BRA_CLICK_SENTIMENT: 'BRA_Click Sentiment',
      BRA_OPEN_SENTIMENT_VIDEO: 'BRA_Open Sentiment Video',
      BRA_FILTER_SENTIMENT: 'BRA_Filter Sentiment',
    },
    OVERVIEW: {
      SWITCH_TAB: 'BRA_Switch Tab',
      FILTER_CONTENT_TYPE: 'BRA_Filter Content Type',
      CLICK_TOP_VIDEO: 'BRA_Click Top Video',
      CLICK_SEE_ALL_REACH: 'BRA_Click Ver Todos Alcance',
      CLICK_CREATOR: 'BRA_Click Creator',
      CLICK_SEE_NICHES: 'BRA_Click Ver Nichos',
      CLICK_RADAR_VIDEO: 'BRA_Click Radar Video',
      CLICK_NICHE: 'BRA_Click Nicho',
      CLICK_SEE_ALL_NICHES: 'BRA_Click Ver Todos Nichos',
      CLICK_HASHTAG: 'BRA_Click Hashtag',
      CLICK_SEE_ALL_HASHTAGS: 'BRA_Click Ver Todos Hashtags',
      APPLY_AUDIENCE_FILTER: 'BRA_Apply Audience Filter',
      FILTER_PROVIDER: 'BRA_Filter Provider',
    },
    UPDATE_BRAND_UGC: 'Update brand UGC',
    UPDATE_COMPETITOR_UGC: 'Update competitor UGC',
    UPDATE_BRAND_CHANNELS: 'BRA_Update Brand Channels',
    UPDATE_COMPETITOR_CHANNELS: 'Update competitor channels',
  },
  SEND_CSAT: 'Send CSat',
  RETRY_DASHBOARD_ERROR: 'Retry dashboard error',
  CHANGE_CHART_TYPE: 'Change chart type',
  PRINT_ELEMENT: 'Print element',
  CAT: {
    CLICK_ATTENTION_SHARE: 'CAT_Click Attention Share',
    CLICK_CATEGORY: 'CAT_Click Category',
    OPEN_MOBILE_ZAI: 'CAT_Open Mobile ZAI',
    CLICK_MOBILE_ZAI: 'CAT_Click Mobile ZAI',
    CLICK_ZAI_QUESTION: 'CAT_Click ZAI Question',
    OPEN_HOME: 'CAT_Open Home',
    OPEN_RANK: 'CAT_Open Rank',
    APPLY_ZAI_REMINDER: 'CAT_Apply Zai reminder',
    CONFIGURE_CATEGORY: 'CAT_Configure Category',
    CHANGE_DI_CHART_TYPE: 'CAT_Change DI Chart Type',
    CHANGE_DI_METRIC: 'CAT_Change DI Metric',
    CLICK_DI_BRAND_FILTER: 'CAT_Click DI Brand Filter',
    SELECT_DI_BRAND_ONLY: 'CAT_Select DI Brand Only',
    SELECT_DI_BRAND: 'CAT_Select DI Brand',
    APPLY_DI_BRAND_FILTER_RESET: 'CAT_Apply DI Brand Filter Reset',
    SELECT_DI_SHOW_NICHE: 'CAT_Select DI Show Niche',
    SELECT_DI_HIDE_NICHE: 'CAT_Select DI Hide Niche',
    CLICK_DI_SCREENSHOT: 'CAT_Click DI Screenshot',
    START_DI_CREATE_REPORT: 'CAT_Start DI Create Report',
    SELECT_DI_REPORT_NICHE: 'CAT_Select DI Report Niche',
    FINISH_DI_CREATE_REPORT: 'CAT_Finish DI Create Report',
    CANCEL_DI_CREATE_REPORT: 'CAT_Cancel DI Create Report',
  },
  DASHBOARD: {
    OPEN_CREATOR_COUNTRY_MODAL: 'Open dashboard creator country modal',
    SHARE_CLICK: 'Share dashboard click',
  },
  HOM: {
    SWITCH_FAVORITE_TOPIC: 'HOM_Switch Favorite Topic',
    CLICK_TREND: 'HOM_Click Trend',
    CONFIGURE_EMBED: 'HOM_Configure Embed',
    APPLY_EMBED: 'HOM_Apply Embed',
    START_NEW_JOB: 'Start New Job',
    START_BRIEFING: 'HOME_Start Briefing',
  },
  OPEN_TOPIC: 'Open topic',
  FILTER_METRICS: 'TOP_Filter Metrics',
  GENERATE_BRIEFING_ERROR: 'Generate briefing error',
  BRIEFING: {
    START: 'Start Briefing',
    GENERATE: 'Generate briefing',
    CANCEL: 'Cancel briefing ',
    SEND: 'Send dashboard',
    CANCEL_SEND: 'Cancel send',
    COPY_LINK: 'Copy link briefing',
    SEND_LATER: 'Send later',
    MARK_AS_DONE: 'Mark as done',
  },
  TERRITORY_EMBED: {
    CONFIGURE: 'Configure Embed',
    CUSTOMIZE: 'Customize embed',
    APPLY: 'Apply Embed',
  },
  // Share of attention
  ATT: {
    FILTER_DATE: 'ATT_Filter Date',
    OPEN_SOA: 'ATT_Open SOA',
    CHANGE_GRAPHICS: 'ATT_Change Graphics',
    SWITCH_REASONING: 'ATT_Switch Reasoning',
    SELECT_BRAND: 'ATT_Select Brand',
    SELECT_YOUR_BRAND: 'ATT_Select Your Brand',
    SELECT_RANKING: 'ATT_Select Ranking',
    CLICK_SCREENSHOT: 'ATT_Click Screenshot',
    VIEW_TOOLTIP: 'ATT_View Tooltip',
    SOA_EMPTY: 'ATT_Open SOA Empty',
    APPLY_EMBED: 'ATT_Apply Embed',
    CLICK_QR_CODE: 'ATT_Click QRCode',
    CLICK_SOA_SHARE: 'ATT_Click SOA Share',
    SELECT_SOA_OPTIONS_SHARE: 'ATT_Select SOA Options Share',
    SELECT_CHART_VIEW: 'ATT_Select Chart View',
    FILTER_CHART_DATE: 'ATT_Filter Chart Date',
    CHANGE_CHART_TYPE: 'ATT_Change Chart Type',
    FILTER_COMPETITORS: 'ATT_Filter Competitors',
    CLICK_CHART: 'ATT_Click Chart',
    FILTER_PAGE_DATE: 'ATT_Filter Page Date',
  },
  DASHBOARD_SEARCH: {
    SORTY_BY: 'Sort by dashboard',
    FILTER_TYPE: 'Filter type dashboard',
    FILTER_STATUS: 'Filter status dashboard',
    SEARCH: 'Search dashboard',
  },
  TAG: {
    TAG_OPEN: 'TAG_Open Tags Monitor',
    TAG_EXCLUDE: 'TAG_Exclude Tag',
    TAG_ADD: 'TAG_Add New Tag',
    TAG_DISABLE: 'TAG_Disable Tag',
    TAG_REACTIVATE: 'TAG_Reactivate Tag',
  },
  TOP: {
    SWITCH_TAB: 'TOP_Switch Tab',
    CLICK_RELATED_TOPIC: 'TOP_Click Related Topic',
    SEE_MORE_TOPICS: 'TOP_View More Topics',
    CLICK_NICHE: 'TOP_Click Niche',
    FILTER_CHIP: 'TOP_Filter Chip',
    FILTER_CATEGORY: 'TOP_Filter Category',
    FILTER_TOPIC: 'TOP_Filter Topic',
  },
  NICHE_CONTEXT: {
    SELECT: 'TOP_Select Niche context',
    ADD: 'TOP_Add Niche context',
    DELETE: 'TOP_Delete Niche context',
    CREATE_DASH: 'TOP_Finish create report',
  },
  NICHE_EDITING: {
    OPEN_MODAL: 'TOP_Open Niche Edit Modal',
    CHANGE_TAB: 'TOP_Change Niche Edit Tab',
    RENAME_NICHES: 'TOP_Rename Niches',
    GROUP_NICHES: 'TOP_Group Niches',
    CLOSE_MODAL: 'TOP_Close Niche Edit Modal',
  },
  PRINT_DASHBOARD: 'DAS_Print Dashboard',
  POST: {
    CLICK_UPDATE: 'VID_Click Update',
  },
  DASHBOARD_FOLDERS: {
    OPEN_ADD_TO_FOLDER: 'DAS_Open add to folder modal',
    OPEN_DELETE_FOLDER: 'DAS_Open delete folder modal',
    OPEN_EDIT_FOLDER: 'DAS_Open edit folder modal',
    ADDED_TO_FOLDER: 'DAS_Added to folder',
    CLICK_DASHBOARD_TO_ADD: 'DAS_Add dashboard to create folder',
    CREATE_DASHBOARD_FOLDER: 'DAS_Create dashboard folder',
    CLICK_FOLDER: 'DAS_Click folder',
    DELETE_FOLDER: 'DAS_Delete folder',
    EDIT_FOLDER: 'DAS_Edit folder',
  },
  EXPORT_DASHBOARD_CSV: 'DAS_Export Dashboard CSV',
  WOR: {
    CREATE_NEW: 'WOR_Create new workspace',
    EDIT: 'WOR_Edit workspace',
    CHANGE: 'Change Workspace',
  },
  MEM: {
    REMOVE: 'MEM_Remove members',
  },
  DASHBOARD_TRANSFER: {
    TRANSFER_DASHBOARD_SUCCESS: 'DAS_Transfer dashboard success',
    TRANSFER_DASHBOARD_ERROR: 'DAS_Transfer dashboard error',
  },
  ZAI_QUICK_PROMPTS: 'ZAI_Click Quick Prompts',
  ZAI_SELECT_FEEDBACK: 'ZAI_Select Feedback',
  TOGGLE_NICHE_VIEW: 'TOP_Toggle Niche View',
  FIL_OPEN_MODAL: 'FIL_Open Modal',
  FIL_OPEN_ABOUT: 'FIL_Open About',
  FIL_CLICK_ADD_FILES: 'FIL_Click Add Files',
  FIL_DROP_FILES: 'FIL_Drop Files',
  FIL_CLICK_REMOVE_FILE: 'FIL_Click Remove File',
  FIL_UPLOAD_SUCCESS: 'FIL_Upload Success',
  FIL_UPLOAD_ERROR: 'FIL_Upload Error',
  TOP_OPEN_SEARCH: 'TOP_Search Topic',
  TOP_OPEN_CREATE_REPORT: 'TOP_Open Create Report',
  TOP_CANCEL_CREATE_REPORT: 'TOP_Cancel Create Report',
  INVITE_MEMBERS: {
    INVITE_TO_WORKSPACE: 'Invite to workspace',
    VIEW_ACTIVE_MEMBERS: 'View active members',
    SEND_ACCESS: 'Send access invite',
    COPY_INVITE_LINK: 'Copy invite link',
    CANCEL_INVITE: 'Cancel invite',
    REMOVE_INVITE: 'Remove invite',
  },
  NICHE_TAB: {
    CHANGE_CHART_TYPE: 'Change chart type',
    CHANGE_CHART_METRIC: 'Change chart metric',
  },
  LIV: {
    OPEN_LIVE_EVENT: 'LIV_Open Live Event',
    SWITCH_TAB: 'LIV_Switch Tab',
    OPEN_COMPETITIVE_SET: 'LIV_Open Competitive Set',
    SWITCH_COMPETITIVE_SET_TAB: 'LIV_Switch Competitive Set Tab',
    SEARCH_COMPETITIVE_SET: 'LIV_Search Competitive Set',
    ADD_COMPETITOR: 'LIV_Add Competitor',
    REVIEW_COMPETITIVE_SET: 'LIV_Review Competitive Set',
    EXCLUDE_COMPETITOR: 'LIV_Exclude Competitor',
    APPLY_COMPETITIVE_SET: 'LIV_Apply Competitive Set',
    CANCEL_COMPETITIVE_SET: 'LIV_Cancel Competitive Set',
    OPEN_ALL_VIDEOS: 'LIV_Open All Videos',
    SEARCH_VIDEOS: 'LIV_Search Videos',
    TOGGLE_BRAND_VIDEOS: 'LIV_Toggle Brand Videos',
    FILTER_SOURCE: 'LIV_Filter Source',
    FILTER_BRAND: 'LIV_Filter Brand',
    FILTER_PROVIDER: 'LIV_Filter Provider',
    SEARCH_LIVE_EVENTS: 'LIV_Search Live Events',
    FILTER_LIVE_EVENTS_STATUS: 'LIV_Filter Live Events Status',
    SORT_LIVE_EVENTS: 'LIV_Sort Live Events',
    CLICK_LIVE_EVENT_CARD: 'LIV_Click Live Event Card',
  },
  TREND: {
    CARD: 'Trend Card',
    SEARCH: 'Trend Search',
  },
} as const
